import api from '@/api';

import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
// import state from './state';

import { SET_IS_GUIDED_TUTORIAL_ON, SET_GUIDED_TUTORIALS, SET_DOCS_OPEN } from './mutations';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const fetchGuidedTutorials = buildActionObject('fetchGuidedTutorials');
export const setGuidedTutorials = buildActionObject('setGuidedTutorials');
export const setIsGuidedTutorialOn = buildActionObject('setIsGuidedTutorialOn');
export const setDocsOpen = buildActionObject('setDocsOpen');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [fetchGuidedTutorials.action]({ dispatch }) {
		const tutorials = await api.getGuidedTutorials();
		await dispatch(setGuidedTutorials.action, tutorials);
	},
	[setGuidedTutorials.action]({ commit }, payload) {
		commit(SET_GUIDED_TUTORIALS, payload);
	},
	[setIsGuidedTutorialOn.action]({ commit }, payload) {
		commit(SET_IS_GUIDED_TUTORIAL_ON, payload);
	},
	[setDocsOpen.action]({ commit }, payload) {
		commit(SET_DOCS_OPEN, payload);
	},
};

export default actions;
